import React from 'react';
import { Pause, Play } from 'lucide-react';
import PaginationProgressBar from "./PaginationProgressBar";
var PaginationFooter = function (_a) {
    var progress = _a.progress, currentPage = _a.currentPage, totalPages = _a.totalPages, goToNextPage = _a.goToNextPage, goToPreviousPage = _a.goToPreviousPage, isPaused = _a.isPaused, onTogglePause = _a.onTogglePause;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "fixed bottom-[80px] left-0 w-full z-20" },
            React.createElement(PaginationProgressBar, { progress: progress })),
        React.createElement("footer", { className: "fixed bottom-[40px] left-0 w-full z-20 py-1 text-center bg-gray-900/80 flex justify-between items-center px-6 border-t border-gray-800", style: { minHeight: 40 } },
            React.createElement("button", { onClick: goToPreviousPage, className: "text-gray-400 hover:text-gray-200 transition" }, "\u2190 Anterior"),
            React.createElement("span", { className: "text-gray-400 flex items-center gap-2" },
                React.createElement("span", null,
                    "P\u00E1gina ",
                    currentPage + 1,
                    " de ",
                    totalPages),
                React.createElement("button", { onClick: onTogglePause, className: "p-1 rounded-md transition-colors ".concat(isPaused
                        ? 'text-green-400 hover:text-green-300'
                        : 'text-yellow-400 hover:text-yellow-300'), style: { lineHeight: 0 } }, isPaused ? React.createElement(Play, { size: 18 }) : React.createElement(Pause, { size: 18 }))),
            React.createElement("button", { onClick: goToNextPage, className: "text-gray-400 hover:text-gray-200 transition" }, "Pr\u00F3xima \u2192"))));
};
export default PaginationFooter;
